export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-rightlast-990834bc888601bcd2c57b3d73a73799.png";